export default __webpack_public_path__ + "static/media/happy-background.dcf29173.svg";